document.addEventListener("click", function (e) {
  // SS - Product Tabs (sections/ss-product-tabs.liquid) lives in its own
  // section, separate from the main product section. The vendor tab
  // behaviour (assets/empire.js RichText -> grouped-content library) only
  // initialises within the section component that finds [data-product-description]
  // inside its own root element, so it never picks this section up - this
  // replicates the same click-to-switch behaviour independently, scoped
  // only to .ss-product-tabs so it can't conflict with the vendor's own
  // tabs elsewhere on the page.
  var wrapper = e.target.closest(".ss-product-tabs");
  if (!wrapper) return;

  var trigger = e.target.closest(".tabs > li");
  if (!trigger) return;

  var tabsList = trigger.parentElement;
  var contentList = wrapper.querySelector(".tabs-content");
  if (!contentList) return;

  var triggers = Array.prototype.slice.call(tabsList.children);
  var contents = Array.prototype.slice.call(contentList.children);
  var index = triggers.indexOf(trigger);
  if (index === -1 || !contents[index]) return;

  triggers.forEach(function (el) {
    el.classList.remove("active");
  });
  contents.forEach(function (el) {
    el.classList.remove("active");
  });

  trigger.classList.add("active");
  contents[index].classList.add("active");
});

document.addEventListener("click", function (e) {
  // "Write a review" (snippets/product.liquid) links to "#" since the
  // Reviews.io block now lives inside the Product Tabs "Reviews" tab -
  // handle it in JS instead: activate that tab (identified by
  // data-tab-trigger/data-tab-panel, not index, since optional tabs shift
  // the Reviews position) and scroll to it directly.
  var link = e.target.closest(".product-review-summary__write-link");
  if (!link) return;

  var wrapper = document.querySelector(".ss-product-tabs");
  var reviewsTrigger = wrapper && wrapper.querySelector('[data-tab-trigger="reviews"]');
  var reviewsPanel = wrapper && wrapper.querySelector('[data-tab-panel="reviews"]');
  if (!reviewsTrigger || !reviewsPanel) return;

  e.preventDefault();

  var triggers = Array.prototype.slice.call(reviewsTrigger.parentElement.children);
  var contents = Array.prototype.slice.call(reviewsPanel.parentElement.children);

  triggers.forEach(function (el) {
    el.classList.remove("active");
  });
  contents.forEach(function (el) {
    el.classList.remove("active");
  });

  reviewsTrigger.classList.add("active");
  reviewsPanel.classList.add("active");

  // Scroll to the Reviews trigger itself, not just the section top - on
  // mobile the tabs render as a stacked accordion, so the Reviews header
  // (and its now-open panel right after it) can sit well below the section's
  // top edge behind the other collapsed section headers.
  reviewsTrigger.scrollIntoView({ behavior: "smooth", block: "start" });
});

document.addEventListener("click", function (e) {
  // Assets & FAQs tab (sections/ss-product-tabs.liquid) - FAQ accordion.
  // Only one question is expanded at a time within its accordion.
  var question = e.target.closest(".product-faq-accordion__question");
  if (!question) return;

  var item = question.closest(".product-faq-accordion__item");
  var accordion = question.closest(".product-faq-accordion");
  if (!item || !accordion) return;

  var isActive = item.classList.contains("active");

  Array.prototype.slice.call(accordion.children).forEach(function (el) {
    el.classList.remove("active");
    var btn = el.querySelector(".product-faq-accordion__question");
    if (btn) btn.setAttribute("aria-expanded", "false");
  });

  if (!isActive) {
    item.classList.add("active");
    question.setAttribute("aria-expanded", "true");
  }
});
